import {
  MARKET_COUNTRY_OPTIONS,
  PRODUCT_LANGUAGE_OPTIONS,
  restoredProductLanguage,
} from "../onboarding/experience-catalog.mjs";

const LANGUAGE_PROFILE_BY_CODE = new Map(
  PRODUCT_LANGUAGE_OPTIONS.map((language) => [language.code, language]),
);
const MARKET_COUNTRY_CODES = new Set(MARKET_COUNTRY_OPTIONS.map((country) => country.code));
const MARKET_REGIONAL_LOCALE_LANGUAGES = new Set(["en", "es", "fr"]);

function languageProfile(value) {
  const code = restoredProductLanguage(value) || "en";
  return LANGUAGE_PROFILE_BY_CODE.get(code) || LANGUAGE_PROFILE_BY_CODE.get("en");
}

export function documentLanguageMetadata(value, country) {
  const profile = languageProfile(value);
  return Object.freeze({
    lang: productLocaleForCountry(profile.code, country),
    dir: profile.direction,
  });
}

export function productLocaleForCountry(value, country) {
  const profile = languageProfile(value);
  const region = String(country || "")
    .trim()
    .toUpperCase();
  if (MARKET_REGIONAL_LOCALE_LANGUAGES.has(profile.code) && MARKET_COUNTRY_CODES.has(region)) {
    return `${profile.code}-${region}`;
  }
  return profile.localeTag;
}
